<!-- In the chat window's frame (src/_cura-window.scss, panel class ai-recording-panel), as the
     other AI dialogs are. -->
<div class="cw-header">
    <mat-icon class="kind">auto_awesome</mat-icon>
    <div class="title">
        <span class="name">Clinical summary</span>
        <span class="subtitle">{{ patientName }}</span>
    </div>
</div>

<mat-dialog-content class="summary-dialog-content cw-body">

    <!-- Not decoration. A tidy list of clinical facts reads as record unless it says otherwise,
         and every line below is AI-authored prose rather than anything a clinician wrote. -->
    <div class="cw-notice">
        <mat-icon>auto_awesome</mat-icon>
        <span>
            AI-generated background, drawn from this patient's notes to give context at a glance.
            It is <strong>not part of the clinical record</strong> and is never used as evidence
            for a code - check the notes before relying on any of it.
        </span>
    </div>

    <div class="loading-row" *ngIf="loading">
        <mat-spinner diameter="28"></mat-spinner>
        <span>Loading summary&hellip;</span>
    </div>

    <p class="error-text" *ngIf="loadError">{{ loadError }}</p>

    <p class="cw-hint" *ngIf="!loading && !loadError && points.length === 0">
        No summary has been generated for this patient yet. One is written the first time the
        coding pipeline reviews their timeline.
    </p>

    <!-- A timeline, newest first. One heading per date rather than the date repeated on every
         line, and diagnoses and procedures in one stream — a resection and the findings from
         that same day belong together, not in separate sections. -->
    <div class="timeline">
        <div class="day" *ngFor="let day of timeline">
            <div class="day-header">
                <span class="day-marker"></span>
                <span class="day-label" [class.undated]="!day.key">{{ day.label }}</span>
            </div>
            <div class="day-points">
                <div class="summary-point" *ngFor="let p of day.points">
                    <span class="point-kind" *ngIf="categoryLabel(p.category)">
                        {{ categoryLabel(p.category) }}
                    </span>
                    <span class="point-text">{{ p.text }}</span>
                </div>
            </div>
        </div>
    </div>

    <!-- Shown so an old summary is visibly old. A clinician deciding how much weight to give it
         needs to know whether it predates the notes they are reading. -->
    <p class="generated-at" *ngIf="!loading && generatedAt">
        Last updated {{ generatedAt | date:'d MMM y, HH:mm' }}
    </p>

</mat-dialog-content>

<mat-dialog-actions class="cw-actions">
    <span class="spacer"></span>
    <button mat-stroked-button class="quiet-button" (click)="close()">Close</button>
</mat-dialog-actions>
